<template>
  <div class="asideMenu">
    <el-menu :uniqueOpened="false" :unique-opened='false' active-text-color='#fff' router :default-active="$route.path" background-color="#2A3754" text-color="#fff" class="el-menu-vertical-demo" active-background-color="#364669" mode='vertical'>
      <el-menu-item index="/class/myClass"><i class="el-icon-school"></i><span class="name">我的班级</span></el-menu-item>
      <el-submenu index="2">
        <template #title><i class="el-icon-notebook-2"></i><span class="name">数据中心</span></template>
        <el-menu-item index="/dataCenter" style="padding-left:70px"><i class="el-icon-s-grid"></i><span class="litter-name">数据面板</span></el-menu-item>
        <el-menu-item index="/dataCenter/achievementData" style="padding-left:70px"><i class="el-icon-document-checked"></i><span class="litter-name">成绩数据</span></el-menu-item>
        <el-menu-item index="/dataCenter/contrastData" style="padding-left:70px"><i class="el-icon-document-copy"></i><span class="litter-name">对比分析</span></el-menu-item>
        <el-menu-item index="/dataCenter/report" style="padding-left:70px" @click="loadHtmlPage">
          <i class="el-icon-document"></i>
          <span class="litter-name">集训报告</span>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template #title><i class="el-icon-video-play"></i><span class="name">兑换中心</span></template>
        <el-menu-item index="/exchange" style="padding-left:70px"><i class="el-icon-s-platform"></i><span class="litter-name">兑换审核</span></el-menu-item>
        <el-menu-item index="/exchange/exchangeProgress" style="padding-left:70px"><i class="el-icon-video-camera"></i><span class="litter-name">兑换进度</span></el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: "tabs",
  data() {
    return {
    };
  },
  methods: {
    async loadHtmlPage() {
      try {
        const yycdid = sessionStorage.getItem('yycdid') || ''
        const userInfoStr = sessionStorage.getItem('userInfo')
        const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
        const token = sessionStorage.getItem('token') || ''
        const jsmc = userInfo?.jsmc || ''
        const realname = userInfo?.realname || ''
        const yhid = userInfo?.yhid || ''
        const yhm = userInfo?.yhm || ''
        const zhid = userInfo?.zhid || ''
        const zhmc = userInfo?.zhmc || ''

        const params = new URLSearchParams({
          token,
          jsmc,
          realname,
          yhid,
          yhm,
          zhid,
          zhmc,
          yycdid
        }).toString()
        // 根据当前网站域名选择报告服务域名
        const hostname = window.location.hostname
        let reportBaseUrl
        if (hostname.includes('idechat.com')) {
          reportBaseUrl = 'https://jxreport.idechat.com'
        } else if (hostname.includes('ideaigc.com')) {
          reportBaseUrl = 'https://jxreport.ideaigc.com'
        }
        const reportUrl = `${reportBaseUrl}/report/entry?${params}`
        // 新窗口打开
        window.open(reportUrl, '_blank')
      } catch (error) {
        console.error('加载页面失败', error)
      }
    },
  }
};
</script>
<style scoped="scoped" lang="scss">
.asideMenu {
  // padding-top: 20px;
  width: 230px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: #364669;
  .el-menu {
    padding-top: 20px !important;
  }
}
.title {
  width: 100%;
  background: #364669;
  height: 70px;
  text-align: center;
  font-size: 20px;
  line-height: 70px;
  float: left;

  span {
    font-size: 20px;
    line-height: 70px;
    color: #fff;
  }
}
.name {
  font-size: 18px;
}
.litter-name {
  font-size: 16px;
}
.el-menu {
  border-right: none;
}
.el-menu-vertical-demo {
  width: 100%;
  height: 100%;

  ::v-deep .el-submenu__title {
    font-size: 18px !important;
  }
  .el-menu-item {
    font-size: 16px;
  }
}
.el-menu-item.is-active {
  background-color: #364669 !important;
}
.el-submenu__title:hover {
}
.el-menu-item:hover {
}
</style>
